import axios from "axios"

export const refreshToken = async () => {
    const response = await axios.post('https://securetoken.googleapis.com/v1/token?key=AIzaSyCjDWb8HDWi_tgBw8eFsixXY9iw9uFCisw', {
        "grant_type": "refresh_token",
        "refresh_token": localStorage.getItem("refreshToken")
    });
    const {data} = response;
    localStorage.setItem("token",data.access_token);
}